
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/[slug]",
      function () {
        return require("private-next-pages/cases/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cases/[slug]"])
      });
    }
  